// eslint-disable-next-line check-file/filename-blocklist
export enum PageTypes {
    Unknown = -1,
    Home = 9100,
    Search = 9101,
    Details = 9102,
    Login = 221,
    BookingForm1 = 9104,
    BookingForm2 = 9105,
    ThankYou = 9106,
    PageNotFound = 9107,
    City = 9109,
    Country = 9110,
    Area = 9111,
    Region = 9112,
}
